// extracted by mini-css-extract-plugin
export default {"avatar":"partnerSearchPopup-deprecated__avatar___P4TwZ"};